import styled from '@emotion/styled';

export const InputGroupStyles = styled.div`
    .form-control:disabled,
    .form-control[readonly] {
        cursor: not-allowed;
    }

    button:disabled,
    .disabled {
        cursor: not-allowed;
    }

    .append {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
    }

    .prepend {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
    }
`;
